import { render, staticRenderFns } from "./thirdPartyLogin.vue?vue&type=template&id=86fa3480&scoped=true"
import script from "./thirdPartyLogin.vue?vue&type=script&lang=js"
export * from "./thirdPartyLogin.vue?vue&type=script&lang=js"
import style0 from "./thirdPartyLogin.vue?vue&type=style&index=0&id=86fa3480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fa3480",
  null
  
)

export default component.exports